import { ButtonProps } from '@material-ui/core';
import closeButtonConfig, { AlmeCloseIconConfig } from '../AlmeCloseIcon/AlmeCloseIconConfig';

export interface DialogConfig extends AlmeCloseIconConfig {
    helperText?: string;
    styles: {
        buttons: {
            color: ButtonProps['color'];
            variant: ButtonProps['variant'];
        };
    };
}

export interface AlmeDialogConfig {
    dialog: DialogConfig;
}

/**
 * This is the baseline dialog config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeDialogConfig = {
    dialog: {
        ...closeButtonConfig,
        helperText: 'Please type a message to continue.',
        styles: {
            buttons: {
                color: 'primary',
                variant: 'contained',
            },
        },
    },
};

export default defaultConfig;
